// 9 Oct: the seat nonce (api/src/core/seat.ts). When another device takes this player's seat (a rejoin by email after
// the seat went quiet, or a proved join), the server refuses this device's session from then on with 401 and the
// reason `seat-moved` on every call that acts for the seat: answers, GET /me, the claim form, the heartbeat and verify.
// The senders mark it on the game store (markSeatMoved); the game page forgets the session for the battle and goes back
// to its join page, which says the seat moved (Join's resume notice). An expired session is a different 401, with no reason.
import { ApiError } from './api';

/** The reason the server puts beside the 401. */
export const SEAT_MOVED = 'seat-moved';

/** True for the refusal that means another device holds the seat now (a plain boolean: the callers go on to judge other refusals of the same error). */
export const isSeatMoved = (e: unknown): boolean => e instanceof ApiError && e.status === 401 && e.body.reason === SEAT_MOVED;
